/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CalendarStrictHttpResponse } from '../../calendar-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendarModel } from '../../models/calendar-model';

export interface ConsumerCalendarPost$Params {
      body?: CalendarModel
}

export function consumerCalendarPost(http: HttpClient, rootUrl: string, params?: ConsumerCalendarPost$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, consumerCalendarPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as CalendarStrictHttpResponse<void>;
    })
  );
}

consumerCalendarPost.PATH = '/Consumer/Calendar';
